import { useTranslation } from "react-i18next";
import LegalDocView from "@/components/legal/LegalDocView";
import { getGdprDoc } from "@/content/legal";
import { FACE_DATA_POLICY_PATH, getFaceDataPolicyCopy } from "@/content/faceDataPolicy";

/**
 * Public GDPR/RGPD data-protection policy, served at /privacy, /rgpd and
 * /data-protection. Content is authored per locale in src/content/legal and
 * rendered by LegalDocView; the active UI language selects the translation (English fallback).
 */
const LegalPolicy = () => {
  const { i18n } = useTranslation();
  const { seeAlso } = getFaceDataPolicyCopy(i18n.language);
  return <LegalDocView doc={getGdprDoc(i18n.language)} seeAlso={{ ...seeAlso, href: FACE_DATA_POLICY_PATH }} />;
};

export default LegalPolicy;
